module.exports = __webpack_public_path__ + "img/xiaohongshu.5564a4cb.svg";